import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { ImportCustomersResponseData, ImportCustomersSchema } from "schema"
import { z } from "zod"
import { runningCustomerImportsQueryKey } from "../lib/runningCustomerImportsQuery"

type Props = {
  onSuccess: (data: z.infer<typeof ImportCustomersResponseData>) => void
}

type MutationProps = {
  file: File
} & z.input<typeof ImportCustomersSchema>

export const useImportCustomersMutation = ({ onSuccess }: Props) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (body: MutationProps) => {
      const response = await axios.post<{
        data: z.infer<typeof ImportCustomersResponseData>
      }>(`/importers/customers`, body)

      onSuccess(response.data.data)

      if ("importId" in response.data.data) {
        queryClient.invalidateQueries({ queryKey: runningCustomerImportsQueryKey })
      }

      return response.data
    },
  })
}
